module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_32.947b14de.png";